var _class, _GroupPreview;
import "core-js/modules/es.symbol.description.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { observer } from "mobx-react";
import PropTypes from "prop-types";
import { Component } from "react";
import { withTranslation } from "react-i18next";
import parseCustomMarkdownToReact from "../Custom/parseCustomMarkdownToReact";
import { addRemoveButtonClicked, allMappableMembersInWorkbench } from "../DataCatalog/DisplayGroupHelper";
import measureElement from "../HOCs/measureElement";
import SharePanel from "../Map/Panels/SharePanel/SharePanel";
import DataPreviewSections from "./DataPreviewSections";
import DataPreviewUrl from "./DataPreviewUrl";
import Styles from "./mappable-preview.scss";
import WarningBox from "./WarningBox";

/**
 * A "preview" for CatalogGroup.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
let GroupPreview = observer(_class = (_GroupPreview = class GroupPreview extends Component {
  backToMap() {
    this.props.viewState.explorerPanelIsVisible = false;
  }
  render() {
    var _this$props$previewed, _this$props$previewed2, _this$props$previewed3, _this$props$previewed4;
    const metadataItem = this.props.previewed.nowViewingCatalogItem || this.props.previewed;
    const {
      t
    } = this.props;
    return /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsxs("div", {
        className: Styles.titleAndShareWrapper,
        ref: component => this.refToMeasure = component,
        children: [/*#__PURE__*/_jsx("h3", {
          children: this.props.previewed.name
        }), /*#__PURE__*/_jsxs("div", {
          className: Styles.shareLinkWrapper,
          children: [this.props.previewed.displayGroup === true && /*#__PURE__*/_jsx("button", {
            type: "button",
            onClick: event => {
              addRemoveButtonClicked(this.props.previewed, this.props.viewState, this.props.terria, event.shiftKey || event.ctrlKey);
            },
            className: Styles.btnAddAll,
            children: allMappableMembersInWorkbench(this.props.previewed.members, this.props.terria) ? t("models.catalog.removeAll") : t("models.catalog.addAll")
          }), /*#__PURE__*/_jsx(SharePanel, {
            catalogShare: true,
            modalWidth: this.props.widthFromMeasureElementHOC,
            terria: this.props.terria,
            viewState: this.props.viewState
          })]
        })]
      }), ((_this$props$previewed = this.props.previewed.loadMetadataResult) === null || _this$props$previewed === void 0 ? void 0 : _this$props$previewed.error) && /*#__PURE__*/_jsx(WarningBox, {
        error: (_this$props$previewed2 = this.props.previewed.loadMetadataResult) === null || _this$props$previewed2 === void 0 ? void 0 : _this$props$previewed2.error,
        viewState: this.props.viewState
      }), ((_this$props$previewed3 = this.props.previewed.loadMembersResult) === null || _this$props$previewed3 === void 0 ? void 0 : _this$props$previewed3.error) && /*#__PURE__*/_jsx(WarningBox, {
        error: (_this$props$previewed4 = this.props.previewed.loadMembersResult) === null || _this$props$previewed4 === void 0 ? void 0 : _this$props$previewed4.error,
        viewState: this.props.viewState
      }), /*#__PURE__*/_jsx("div", {
        className: Styles.previewedInfo,
        children: /*#__PURE__*/_jsxs("div", {
          className: Styles.url,
          children: [this.props.previewed.description && this.props.previewed.description.length > 0 && /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("h4", {
              className: Styles.h4,
              children: t("description.name")
            }), parseCustomMarkdownToReact(this.props.previewed.description, {
              catalogItem: this.props.previewed
            })]
          }), /*#__PURE__*/_jsx(DataPreviewSections, {
            metadataItem: metadataItem
          }), metadataItem.dataCustodian && /*#__PURE__*/_jsxs("div", {
            children: [/*#__PURE__*/_jsx("h4", {
              className: Styles.h4,
              children: t("preview.dataCustodian")
            }), parseCustomMarkdownToReact(metadataItem.dataCustodian, {
              catalogItem: metadataItem
            })]
          }), metadataItem.url && metadataItem.url.length && !metadataItem.hideSource && /*#__PURE__*/_jsx(DataPreviewUrl, {
            metadataItem: metadataItem
          })]
        })
      })]
    });
  }
}, _defineProperty(_GroupPreview, "propTypes", {
  previewed: PropTypes.object.isRequired,
  terria: PropTypes.object.isRequired,
  viewState: PropTypes.object.isRequired,
  widthFromMeasureElementHOC: PropTypes.number,
  t: PropTypes.func.isRequired
}), _GroupPreview)) || _class;
export default withTranslation()(measureElement(GroupPreview));